

/*
 * Date: 2025
 * Description: Logout page
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { useNavigate } from "react-router-dom";
import { useEffect , ReactElement , useState , useContext } from "react";
import { MainContext } from "../context/context";
import { Box } from "@mui/material";

//Utility
import { delay } from "../utils/utility";
import { handleLogout } from "../api/fetch";

//Components
import CircularUnderLoad from "../components/utils/center.loader";

//Interfaces && Types

//Context
import { SocketContext } from "../context/socket.context";

const Logout = () : ReactElement => {

    const Nav = useNavigate();
    const socket = useContext(SocketContext)
    const { HandleLogout , user } = useContext(MainContext)

    const [ loading , setLoading ] = useState<boolean>(true)
    useEffect(() => { 
        setLoading(true)
        const logout = async() => { 
            socket.disconnect()
            await delay(1000)
            await handleLogout()
            HandleLogout(Nav)
        }
        logout()
    },[HandleLogout , Nav , socket , user ])
    return (
        <Box component="div">
          { loading &&< CircularUnderLoad type={"full"}/> }
        </Box>
    )
}
export default Logout